import { AngularFirestore } from 'angularfire2/firestore';
import { Pet } from 'src/app/auth/_models/pet';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { PetsService } from 'src/app/auth/_services/pets.service';
import { pipe } from 'rxjs';
import { take } from 'rxjs/operators';
import { BlockUi } from 'src/app/auth/_helpers';

@Component({
  selector: 'app-pet-delete',
  templateUrl: './pet-delete.component.html',
  styleUrls: ['./pet-delete.component.css']
})
export class PetDeleteComponent implements OnInit {

  pet: Pet;
  num1;
  num2;
  operator;
  result: number;
  answer: number;

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
    private _petsService: PetsService,
    private _blockUi: BlockUi
  ) { }

  generateOperation() {
    this.num1 = Math.floor(Math.random() * (10 - 1 + 1)) + 1;
    this.num2 = Math.floor(Math.random() * (10 - 1 + 1)) + 1;
    const ops = ['+', '-'];

    const opindex = Math.floor(Math.random() * 2);
    this.operator = ops[opindex];

    switch (opindex) {
      case 0: this.result = this.num1 + this.num2; break;
      case 1: this.result = this.num1 - this.num2; break;
    }
  }

  ngOnInit() {
    this.generateOperation();
    this._activatedRoute.parent.params.subscribe(params => {
      const uuid = params['id'];
      this._petsService.getPetById(uuid)
        .subscribe(pet => {
          this.pet = pet;
        });
    });
  }

  deletePet(pet: Pet) {

    if (this.answer === this.result) {
      if (pet) {
        this._blockUi.block();
        this._petsService.deletePet(pet)
          .then(function () {
          }).catch(error => {
            console.log('ERRO:', error);
          });
        this._blockUi.unblock();
        this._router.navigateByUrl('pets/listar');
      } else {
        this._blockUi.unblock();
      }
    } else {
      this.answer = null;
      this.generateOperation();
    }

  }

}
